<template>
  <transition name="nut-mask-fade">
    <!-- <div class="nut-mask" @click="modalClick" :class="[customClass]" v-show="visible"><slot></slot></div> -->
    <div class="tools-fixed">
      <div @click="onToHome" v-if="hasHomeIcon" class="tool-item home">
        <img
          src="https://img12.360buyimg.com/jrpmobile/jfs/t1/17437/38/263/3953/5c0899a3E36863357/cc9b13241271fc4a.png"
          alt
        >
      </div>
      <div @click="onToCategory" v-if="hasCategoryIcon" class="tool-item category">
        <img
          src="https://img12.360buyimg.com/jrpmobile/jfs/t1/29949/32/282/3341/5c0899a3E18f7e9fb/9f3143d96eebec5a.png"
          alt
        >
      </div>
      <div class="tool-item toTop" v-show="visible" :screenNum="screenNum" @click="goTop">
        <img
          src="https://img12.360buyimg.com/jrpmobile/jfs/t1/9034/25/7764/4454/5c08bd64E2ce6d4c6/afc8fff43ca1881e.png"
          alt
        >
      </div>
    </div>
  </transition>
</template>
<script>
import { isMiniProgram } from '@/util/common';

export default {
  name: 'SearchBackTop',
  props: {
    screenNum: {
      type: Number,
      default: 1
    },
    hasHomeIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasCategoryIcon: false,
      visible: false
    };
  },
  methods: {
    onToHome() {
      window.location.href = window.location.origin + window.location.pathname;
    },
    goTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
      this.visible = false;
    },
    onToCategory() {
      // window.location.replace(`${window.location.origin + window.location.pathname}#/category`);
      window.location.href = `${window.location.origin + window.location.pathname}#/category`;
    },
    requestAniFrame() {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function(callback) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    }
  },
  watch: {},
  created() {
    if (isMiniProgram()) {
      this.hasCategoryIcon = true;
    }
  },
  mounted() {
    const win = window;
    const requestAniFrame = this.requestAniFrame();
    let winHeight = win.innerHeight;
    let scheduledAniFrame = false;

    win.addEventListener('scroll', () => {
      if (scheduledAniFrame) return;
      scheduledAniFrame = true;
      requestAniFrame(() => {
        scheduledAniFrame = false;
        if ((document.documentElement.scrollTop || document.body.scrollTop) > winHeight * this.screenNum) {
          this.visible = true;
        } else {
          this.visible = false;
        }
      });
    });
  }
};
</script>
<style lang="scss" scoped>
@import '@/scss/mixin.scss';

.tools-fixed {
  position: fixed;
  right: $rem20;
  bottom: $rem40;
  width: $rem72;
  z-index: 100;
  box-sizing: content-box;
  padding-bottom: constant(safe-area-inset-bottom) !important;
  padding-bottom: env(safe-area-inset-bottom) !important;

  .tool-item {
    margin-top: $rem20;
    width: $rem72;
    height: $rem72;
  }

  img {
    width: $rem72;
    height: $rem72;
  }

  &.toTop {
    bottom: $rem40;
  }
}
</style>
